import axios from 'axios';
import { setupInterceptors } from './interceptors';

const axiosClient = axios.create({
  baseURL:import.meta.env.VITE_API_BASE_URL, // Base URL for the API
});

setupInterceptors(axiosClient);

export default axiosClient;
